import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Main from './Main';
import ContactInformation from './routes/ContactInformation';
import Contents from './routes/Contents';
import CountryFrom from './routes/CountryFrom';
import CountryNotSupported from './routes/CountryNotSupported';
import CountrySpecific from './routes/CountrySpecific';
import CountryTo from './routes/CountryTo';
import DHLAccount from './routes/DHLAccount';
import Gift from './routes/Gift';
import Incoterm from './routes/Incoterm';
import Instructions from './routes/Instructions';
import LandingPage from './routes/LandingPage';
import Manuals from './routes/Manuals';
import NoProforma from './routes/NoProforma';
import SuccessPage from './routes/SuccessPage';
import USState from './routes/USState';
import ValueOfPackage from './routes/ValueOfPackage';
import './styles/style.scss';
import { ProvideBreadcrumbs } from './util/BreadcrumbContext';
import SnackbarProvider from 'react-simple-snackbar';

const App = () => (
    <BrowserRouter>
        <ProvideBreadcrumbs>
            <SnackbarProvider>
                <Main>
                    <Routes>
                        <Route path='/' element={<LandingPage />} />
                        <Route path='/from' element={<CountryFrom />} />
                        <Route path='/to' element={<CountryTo />} />
                        <Route path='/no-proforma' element={<NoProforma />} />
                        <Route
                            path='/country-not-supported'
                            element={<CountryNotSupported />}
                        />
                        <Route
                            path='/state-not-supported'
                            element={<CountryNotSupported usstate={true} />}
                        />
                        <Route
                            path='/country/:countryID'
                            element={<CountrySpecific />}
                        />
                        <Route path='/incoterm' element={<Incoterm />} />
                        <Route path='/gift' element={<Gift />} />
                        <Route path='/value' element={<ValueOfPackage />} />
                        <Route
                            path='/instructions'
                            element={<Instructions />}
                        />
                        <Route path='/dhl-account' element={<DHLAccount />} />
                        <Route path='/state' element={<USState />} />
                        <Route path='/state/:usstate' element={<USState />} />
                        {/* <Route path='/manuals' element={<Manuals />} /> */}
                        <Route
                            path='/contact-information'
                            element={<ContactInformation />}
                        />
                        <Route path='/contents' element={<Contents />} />
                        <Route path='/success' element={<SuccessPage />} />
                    </Routes>
                </Main>
            </SnackbarProvider>
        </ProvideBreadcrumbs>
    </BrowserRouter>
);

export default App;
